export const FETCH_VAULTS_SUCCESS = 'LOCKER/FETCH_VAULTS_SUCCESS';
export const FETCH_VAULT_REQUEST = 'LOCKER/FETCH_VAULT_REQUEST';
export const FETCH_VAULT_FAILURE = 'LOCKER/FETCH_VAULT_FAILURE';
export const FETCH_VAULT_SUCCESS = 'LOCKER/FETCH_VAULT_SUCCESS';

export const OPEN_LOCKER_PREPARE_CONFIRM_MODAL = 'LOCKER/MODAL/OPEN_PREPARE_CONFIRM';
export const CLOSE_LOCKER_PREPARE_CONFIRM_MODAL = 'LOCKER/MODAL/CLOSE_PREPARE_CONFIRM';
export const OPEN_LOCKER_VERIFY_CONFIRM_MODAL = 'LOCKER/MODAL/OPEN_VERIFY_CONFIRM';
export const CLOSE_LOCKER_VERIFY_CONFIRM_MODAL = 'LOCKER/MODAL/CLOSE_VERIFY_CONFIRM';
export const OPEN_LOCKER_UNPREPARE_CONFIRM_MODAL = 'LOCKER/MODAL/OPEN_UNPREPARE_CONFIRM';
export const CLOSE_LOCKER_UNPREPARE_CONFIRM_MODAL = 'LOCKER/MODAL/CLOSE_UNPREPARE_CONFIRM';

export const DEACTIVATE_LOCKER_REQUEST = 'LOCKER/DEACTIVATE_REQUEST';
export const DEACTIVATE_LOCKER_SUCCESS = 'LOCKER/DEACTIVATE_SUCCESS';
export const DEACTIVATE_LOCKER_FAILURE = 'LOCKER/DEACTIVATE_FAILURE';
export const REACTIVATE_LOCKER_REQUEST = 'LOCKER/REACTIVATE_REQUEST';
export const REACTIVATE_LOCKER_SUCCESS = 'LOCKER/REACTIVATE_SUCCESS';
export const REACTIVATE_LOCKER_FAILURE = 'LOCKER/REACTIVATE_FAILURE';

export const FETCH_APPOINTMENT_TASKS_EVENTS_REQUEST = 'LOCKER/APPOINTMENTS/EVENTS/FETCH_EVENTS_REQUEST';
export const FETCH_APPOINTMENT_TASKS_EVENTS_SUCCESS = 'LOCKER/APPOINTMENTS/EVENTS/FETCH_EVENTS_SUCCESS';
export const FETCH_APPOINTMENT_TASKS_EVENTS_FAILURE = 'LOCKER/APPOINTMENTS/EVENTS/FETCH_EVENTS_FAILURE';

export const FETCH_GENERATE_CODE_REQUEST = 'LOCKER/CODE/GENERATE/REQUEST';
export const FETCH_GENERATE_CODE_SUCCESS = 'LOCKER/CODE/GENERATE/SUCCESS';
export const FETCH_GENERATE_CODE_FAILURE = 'LOCKER/CODE/GENERATE/FAILURE';
export const FLUSH_GENERATE_CODE_ERROR = 'LOCKER/CODE/GENERATE/FLUSH_ERROR';

export const FETCH_VALIDATE_CODE_REQUEST = 'LOCKER/CODE/VALIDATE/REQUEST';
export const FETCH_VALIDATE_CODE_SUCCESS = 'LOCKER/CODE/VALIDATE/SUCCESS';
export const FETCH_VALIDATE_CODE_FAILURE = 'LOCKER/CODE/VALIDATE/FAILURE';

export const PATCH_CODE_REQUEST = 'LOCKER/CODE/PATCH/REQUEST';
export const PATCH_CODE_SUCCESS = 'LOCKER/CODE/PATCH/SUCCESS';
export const PATCH_CODE_FAILURE = 'LOCKER/CODE/PATCH/FAILURE';

export const OPEN_CODE_MODAL = 'LOCKER/CODE/MODAL/OPEN';
export const CLOSE_CODE_MODAL = 'LOCKER/CODE/MODAL/CLOSE';
export const SET_UPDATING_CODE = 'LOCKER/CODE/MODAL/SET';

export const POST_LOCKER_REQUEST = 'LOCKER/POST/REQUEST';
export const POST_LOCKER_SUCCESS = 'LOCKER/POST/SUCCESS';
export const POST_LOCKER_FAILURE = 'LOCKER/POST/FAILURE';

export const PUT_LOCKER_REQUEST = 'LOCKER/PUT/REQUEST';
export const PUT_LOCKER_SUCCESS = 'LOCKER/PUT/SUCCESS';

export const DELETE_LOCKER_REQUEST = 'LOCKER/DELETE/REQUEST';
export const DELETE_LOCKER_SUCCESS = 'LOCKER/DELETE/SUCCESS';
export const DELETE_LOCKER_FAILURE = 'LOCKER/DELETE/FAILURE';

export const GET_LOCKERS_REQUEST = 'LOCKERS/GET/REQUEST';
export const GET_LOCKERS_SUCCESS = 'LOCKERS/GET/SUCCESS';
export const GET_LOCKERS_FAILURE = 'LOCKERS/GET/FAILURE';

export const REFRESH_DASHBOARD = 'LOCKERS/DASHBOARD/REFRESH';
export const SET_DASHBOARD_FILTERS = 'LOCKERS/DASHBOARD/SET/FILTERS';

export const OPEN_SHAREBOX_LOCKER_REQUEST = 'LOCKERS/MODAL/OPEN_SHAREBOX_LOCKER_REQUEST';
export const OPEN_SHAREBOX_LOCKER_SUCCESS = 'LOCKERS/MODAL/OPEN_SHAREBOX_LOCKER_SUCCESS';
export const OPEN_SHAREBOX_LOCKER_FAILURE = 'LOCKERS/MODAL/OPEN_SHAREBOX_LOCKER_FAILURE';
